/**
 * NOTE API — Wrapper dei REST Liferay allineato a NotesResourceImpl.java.
 * I 5 metodi CRUD standard vengono da `createCrudApi`.
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET    /notes/{groupId}   (+ page, pageSize, sort, search)  -> Page<Note>
 *   - POST   /notes/{groupId}  NoteInput                           -> Note
 *   - GET    /note/{noteId}                                        -> Note
 *   - PATCH  /note/{noteId}    NoteInput (parziale)                -> Note
 *   - DELETE /note/{noteId}                                        -> 200
 *
 * `noteUpdateToInput` ignora `noteId` (whitelist): passare il payload intero
 * equivale allo strip esplicito.
 */

import type { ServerListParams } from '@crm/shared';
import { createCrudApi } from '../../store/createCrudApi';
import {
  noteFromDto,
  noteCreateToInput,
  noteUpdateToInput,
  type NoteDto,
} from './noteMappers';
import type { Note, NoteCreatePayload, NoteUpdatePayload } from './noteTypes';

export const noteApi = createCrudApi<Note, NoteDto, NoteCreatePayload, NoteUpdatePayload, ServerListParams>({
  collection: '/notes',
  single: '/note',
  fromDto: noteFromDto,
  createToInput: noteCreateToInput,
  updateId: (p) => p.noteId,
  updateToInput: (p) => noteUpdateToInput(p),
});
